import script from "./ChoosingPreference.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChoosingPreference.vue?vue&type=script&setup=true&lang=ts"

import "./ChoosingPreference.vue?vue&type=style&index=0&id=5d7e0240&scoped=true&lang=scss"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d7e0240"]])

export default __exports__